// Vendor Libs
import React from 'react';

// Material UI
import {makeStyles} from '@material-ui/core/styles';
import {CircularProgress} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        color: '#20557b',
        alignItems: 'center',
        justifyContent: 'center',
        height: 'calc(100vh - 64px - 50px)',
        '& > * + *': {
            marginLeft: theme.spacing(2),
        },
    },
    loading: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
}));

const LoadingSpinner = () => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <div className={classes.loading} style={{borderColor: 'red'}}>
                <CircularProgress color="inherit" size={60} thickness={3.0} />
            </div>
        </div>
    );
};

export default LoadingSpinner;
